export default __webpack_public_path__ + "static/mm-7c1dd6f6116236689596313ff245ddbc.png";